import { FilterAltOff } from "@mui/icons-material";
import { IconButton, Tooltip } from "@mui/material";
import { useDispatch } from "react-redux";
import { resetSavedAlbumsFilters } from "../../../../actions/albumListActions";

const ClearFilterButton = () => {
    const dispatch = useDispatch();

    const onClickResetFilter = () => {
        dispatch(resetSavedAlbumsFilters());
    }

    return (
        <Tooltip title="Reset current filters">
            <IconButton color="primary" onClick={onClickResetFilter}>
                <FilterAltOff />
            </IconButton>
        </Tooltip>
    )
}

export default ClearFilterButton;